export const BW_AUTH_STATE = {
  NOT_AUTHENTICATED: 0,
  CHECKING: 1,
  AUTHENTICATED: 2
}

export const BW_AUTH_LANGUAGE_ATTR = 'custom:language'
